import React from 'react';
import PropTypes from 'prop-types';
import Div from './styles';

const propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
  center: PropTypes.bool,
};

function Error({ message, center, className }) {
  return (
    <Div className={className} center={center}>
      {message}
    </Div>
  );
}

Error.propTypes = propTypes;
export default Error;
